export const api = {
  GET_LIST_APPROVAL_INSERT_TRANSACTION: '/index.php?r=api/v1/maintenance_transaction/maintenance-transaction/approval',
  SEND_REJECT_INSERT_TRANSACTION: '/index.php?r=api/v1/maintenance_transaction/maintenance-transaction/reject-on-us',
  SEND_APPROVE_INSERT_TRANSACTION: '/index.php?r=api/v1/maintenance_transaction/maintenance-transaction/approve-on-us',
  GET_DETAIL_REQUEST_INSERT_TRANSACTION: '/index.php?r=api/v1/maintenance_transaction/maintenance-transaction/detail',
};


export const failedReject = (ctx, response) => {
  ctx.commit('setProgressTitle', 'Reject Failed');
  ctx.commit('setProgressColor', 'red');
  ctx.commit('setPercentage', 0);
  ctx.commit('setFailedResponse', true);

  const errorMessages = response?.data?.error_message;
  const errorMessageText = Array.isArray(errorMessages)
    ? errorMessages.join(', ')
    : 'Process failed !';

  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: errorMessageText,
      icon: 'mdi-alert',
      color: 'red',
    },
    { root: true }
  );
  ctx.commit('setLoading', false);

  return false; 
};

export const failedApprove = (ctx, response) => {
  ctx.commit('setProgressTitle', 'Approval Failed');
  ctx.commit('setProgressColor', 'red');
  ctx.commit('setPercentage', 0);
  ctx.commit('setFailedResponse', true);
  const errorMessages = response?.data?.error_message;
  const errorMessageText = Array.isArray(errorMessages)
    ? errorMessages.join(', ')
    : 'Process failed !';

  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: errorMessageText,
      icon: 'mdi-alert',
      color: 'red',
    },
    { root: true }
  );
};

export const successApprove = (ctx, responseData) => {
  ctx.commit('setPercentage', 100);
  ctx.commit('setProgressTitle', 'Approval Complete');
  ctx.commit('setApprovedStatus', {
    payload: 'success',
  });
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: responseData?.message_id || 'Approve Successfully !',
      icon: 'mdi-check',
      color: 'green',
    },
    { root: true }
  );

  ctx.commit('setLoading', false);
};

export const successReject = (ctx, responseData) => {
  ctx.commit('setPercentage', 100);
  ctx.commit('setProgressTitle', 'Reject Complete');
  ctx.commit('setApprovedStatus', {
    payload: 'success',
  });
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: responseData?.message_id || 'Reject Successfully !',
      icon: 'mdi-check',
      color: 'green',
    },
    { root: true }
  );

  ctx.commit('setLoading', false);

};
